import React, { FC } from 'react';
import { BodyText } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { HeadshotsInfoModal } from './HeadshotsInfoModal';

export type HeadshotsMonthlyModalProps = {
  /** Next booking date, formatted as "March 10, 2027". Empty when the BE has no date. */
  nextBookableDate: string;
  onUpgrade: () => void;
  onClose: () => void;
};

/**
 * Upsell shown when a monthly subscriber has used their yearly headshot session.
 * Copy only — eligibility, formatting, and the upgrade flow live in `useHeadshotMonthlyModal`.
 */
export const HeadshotsMonthlyModal: FC<HeadshotsMonthlyModalProps> = ({ nextBookableDate, onUpgrade, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeadshotsInfoModal
      title={t('talent:headshots.monthlyModal.title')}
      body={
        <>
          {t('talent:headshots.monthlyModal.body')}
          {nextBookableDate && (
            <>
              {' '}
              <Trans
                i18nKey="talent:headshots.monthlyModal.nextSession"
                values={{ nextBookableDate }}
                components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
              />
            </>
          )}
          <br />
          <br />
          {t('talent:headshots.monthlyModal.switchToAnnual')}
        </>
      }
      benefits={[
        {
          id: 'annual',
          label: (
            <Trans
              i18nKey="talent:headshots.monthlyModal.annualBenefit"
              components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
            />
          ),
        },
      ]}
      primaryActionLabel={t('talent:headshots.monthlyModal.upgradeNow')}
      onPrimaryAction={onUpgrade}
      secondaryActionLabel={t('talent:headshots.monthlyModal.maybeLater')}
      onSecondaryAction={onClose}
      closeLabel={t('common:button.close')}
      onClose={onClose}
    />
  );
};

export default HeadshotsMonthlyModal;
